module.exports = __webpack_public_path__ + "static/full12-bb5b12fff43f71881f1732e176f431f0.png";